<div class="layer-menu menu550 hideonopen slidedownlayermenu hiddenfirst" id="layermenu"></div>
<div class="layer-menu menu240 hideonopen slidedowntoolmenu hiddenfirst" id="toolmenu"></div>
<div class="legendouter slideuplegendcontaineraction" id="legendcontainer"></div>
<div class="legendresize hidden">Ziehen zum Vergrößern <i class="usericon icon-arrow-combo"></i></div>
